<template>
  <CDialog
    no-header
    v-bind="{ show }"
    @close="$emit('close')"
    custom-class="!max-w-[765px]"
  >
    <div class="p-3 md:p-5 !overflow-hidden">
      <div
        ref="termsContent"
        class="!overflow-y-scroll custom-scroll h-[300px] sm:h-[356px] md:h-[500px] pr-2"
      >
        <div class="terms-content" v-html="data?.content" />
      </div>
      <FCheckbox
        :disabled="!termsDisabled"
        class="my-2 md:my-3"
        :label="$t('terms_&_conditions')"
        v-model="termsConfirm"
      />
      <div class="flex-y-center gap-2 lg:flex-row">
        <CButton
          variant="info"
          :text="$t('cancel')"
          class="w-1/2 md:w-[120px] !text-xs h-9 md:h-12"
          type="button"
          @click="close"
        />
        <CButton
          :disabled="!termsConfirm || regLoading || logLoading"
          variant="primary"
          :text="$t('confirm')"
          icon-position="left"
          class="w-1/2 md:w-[120px] !text-xs h-9 md:h-12"
          type="button"
          :loading="regLoading || logLoading"
          @click="$emit('submit')"
        />
      </div>
    </div>
  </CDialog>
</template>

<script setup lang="ts">
import CDialog from "@/components/Common/Dialog/CDialog.vue";
import FCheckbox from "@/components/Form/FCheckbox.vue";
import { ref, watch, toRefs } from "vue";
import { useScroll } from "@vueuse/core";
import CButton from "@/components/Common/CButton.vue";

interface Props {
  show?: boolean;
  data?: any;
  regLoading?: boolean;
  logLoading?: boolean;
}
defineProps<Props>();

const emit = defineEmits<{
  (e: "close"): void;
  (e: "submit"): void;
}>();

const termsConfirm = ref(false);
const termsDisabled = ref(false);
const termsContent = ref();
const { y, arrivedState } = useScroll(termsContent);
const { bottom } = toRefs(arrivedState);

const close = () => {
  emit("close");
  termsConfirm.value = false;
  termsDisabled.value = false;
};
watch(
  () => bottom.value,
  (val) => {
    if (y.value > 0 && val) {
      termsDisabled.value = true;
    }
  },
);
</script>
<style>
.terms-content a,
.terms-content a span {
  color: #0fd647 !important;
}
.terms-content > p {
  margin-bottom: 8px !important;
  font-family: "Inter", sans-serif !important;
}
.terms-content span {
  font-family: "Roboto", sans-serif !important;
}
.terms-content p,
.terms-content li {
  font-family: "Inter", sans-serif !important;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.terms-content ol,
.terms-content ul {
  padding-left: 16px;
  font-family: "Inter", sans-serif !important;
}
.terms-content ul li {
  list-style: disc;
  position: relative;
  font-family: "Inter", sans-serif !important;
}
.terms-content ol li {
  list-style: auto;
}
.terms-content a {
  color: #16cc53;
}
.terms-content a:hover {
  text-decoration: underline;
}
.terms-content img {
  width: 100%;
  max-height: 438px;
  border-radius: 8px;
}
.terms-content b {
  font-weight: 500;
}

.terms-content h4,
.terms-content h1,
.terms-content h2,
.terms-content h3,
.terms-content h5,
.terms-content h6 {
  font-family: "Inter", sans-serif !important;
  color: #080a15;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  margin-bottom: 12px;
}
@media screen and (max-width: 768px) {
  .terms-content p,
  .terms-content li,
  .terms-content span {
    font-size: 14px !important;
  }
}
</style>
